import React from 'react';

export function TrackSelector({ videoTracks, audioTracks, selectedTracks, onToggle }) {
  const allTracks = [
    ...Array.from(videoTracks.entries()).map(([id, data]) => ({
      id,
      ...data,
      kind: 'video',
    })),
    ...Array.from(audioTracks.entries()).map(([id, data]) => ({
      id,
      ...data,
      kind: 'audio',
    })),
  ];

  if (allTracks.length === 0) {
    return (
      <div className="panel track-selector">
        <h2>Tracks</h2>
        <p className="empty-text">No tracks available</p>
      </div>
    );
  }

  // Group by participant
  const byParticipant = {};
  allTracks.forEach(trackInfo => {
    const identity = trackInfo.participant?.identity || 'Unknown';
    if (!byParticipant[identity]) {
      byParticipant[identity] = [];
    }
    byParticipant[identity].push(trackInfo);
  });

  const getTrackLabel = (trackInfo) => {
    const source = trackInfo.publication?.source || 'unknown';
    const kind = trackInfo.kind;

    if (source === 'screen_share') return 'Screen Video';
    if (source === 'screen_share_audio') return 'Screen Audio';
    if (source === 'camera') return 'Camera';
    if (source === 'microphone') return 'Microphone';

    return `${kind.charAt(0).toUpperCase() + kind.slice(1)}`;
  };

  const getTrackIcon = (trackInfo) => {
    const source = trackInfo.publication?.source || 'unknown';
    const kind = trackInfo.kind;

    if (source === 'screen_share' || source === 'screen_share_audio') return 'monitor';
    if (kind === 'video') return 'videocam';
    if (kind === 'audio') return 'mic';
    return 'stream';
  };

  return (
    <div className="panel track-selector">
      <h2>Tracks ({allTracks.length})</h2>
      <div className="track-list">
        {Object.entries(byParticipant).map(([identity, tracks]) => (
          <div key={identity} className="participant-group">
            <div className="participant-header">{identity}</div>
            {tracks.map(trackInfo => (
              <div key={trackInfo.id} className="track-item">
                <div className="track-item-info">
                  <span className="track-item-name">
                    {getTrackLabel(trackInfo)}
                  </span>
                  <span className="track-item-type">
                    {trackInfo.kind}
                  </span>
                </div>
                <div className="track-toggle">
                  <input
                    type="checkbox"
                    checked={selectedTracks.has(trackInfo.id)}
                    onChange={() => onToggle(trackInfo.id)}
                    id={`track-${trackInfo.id}`}
                  />
                  <label htmlFor={`track-${trackInfo.id}`}>
                    {selectedTracks.has(trackInfo.id) ? 'Visible' : 'Hidden'}
                  </label>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
